import { render, staticRenderFns } from "./MailActivityRight.vue?vue&type=template&id=243ea816"
import script from "./MailActivityRight.vue?vue&type=script&lang=js"
export * from "./MailActivityRight.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports